/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type CallDealerModal_conversation = {
    readonly currentConversationMember?: {
        readonly phoneCallbackEnabled: boolean | null;
    } | null | undefined;
    readonly " $refType": "CallDealerModal_conversation";
};
export type CallDealerModal_conversation$data = CallDealerModal_conversation;
export type CallDealerModal_conversation$key = {
    readonly " $data"?: CallDealerModal_conversation$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"CallDealerModal_conversation">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CallDealerModal_conversation",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "currentConversationMember",
          "args": [
            {
              "kind": "Variable",
              "name": "currentUserId",
              "variableName": "userId"
            }
          ],
          "concreteType": "ConversationMember",
          "kind": "LinkedField",
          "name": "currentMember",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phoneCallbackEnabled",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Conversation",
  "abstractKey": null
};
(node as any).hash = 'a24b3895c8c0adac0f362fcdc7caa9e6';
export default node;
